import { make } from 'vuex-pathify'

const state = {
    title: null,
    drawer: null,
}

export default {
    namespaced: true,
    state,
    mutations: make.mutations(state),
}
